import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import DowngradedModalContainer from 'app/team/components/DowngradedModalContainer';
import { isProfileAdminOfAccount } from 'app/account/Selectors';

const modals = [
  {
    Modal: DowngradedModalContainer,
    shouldRender: (state: any) => {
      const currentAccount = Account.selectors.all.currentAccount(state);
      const currentProfile = Profile.selectors.all.currentProfile(state);
      const helpKey = Profile.selectors.all.currentAccountDowngradedTrackingKey(
        state
      );
      return (
        currentProfile &&
        Account.selectors.all.hasLoaded(state) &&
        Profile.selectors.all.hasLoaded(state) &&
        Account.selectors.wasTeam(currentAccount) &&
        !isProfileAdminOfAccount(currentProfile, currentAccount) &&
        !Profile.selectors.hasViewedHelp(helpKey, currentProfile)
      );
    },
  },
];

const findModal = (state: any): React.ComponentType<any> | null => {
  const modalConfig = _.find(modals, config => config.shouldRender(state));
  return modalConfig ? modalConfig.Modal : null;
};

const mapStateToProps = (state: any) => ({
  Modal: findModal(state),
});

interface GlobalModalHolderProps {
  Modal: React.ComponentType<any> | null;
}

const GlobalModalHolder = ({ Modal }: GlobalModalHolderProps) =>
  Modal && <Modal />;

export default connect(mapStateToProps)(GlobalModalHolder);
